import { CommonsContext } from '@contexts/commons';
import { useContext } from 'react';
export var useCommons = function () {
    var context = useContext(CommonsContext);
    if (!context) {
        throw new Error('useCommons must be used within an CommonsProvider');
    }
    return context;
};
